import { createComponentStore } from "@tecnobit-srl/components-store";
import { jsx } from "react/jsx-runtime";
//#region src/index.tsx
var { Component: InnerContent, ComponentStoreProvider: ContentTypesProvider, useAddComponent: useAddContentType } = createComponentStore("content-types");
function Content(props) {
	return /* @__PURE__ */ jsx(InnerContent, {
		id: props.name,
		p: props
	});
}
//#endregion
export { Content, ContentTypesProvider, useAddContentType };
